import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary: 'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive: 'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        constructive: 'border-transparent bg-emerald-600 text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
        gold: 'border-transparent bg-yellow-400 text-yellow-900 hover:bg-yellow-500',
        silver: 'border-transparent bg-gray-300 text-gray-800 hover:bg-gray-400',
        bronze: 'border-transparent bg-orange-400 text-orange-900 hover:bg-orange-500',
        info: 'border-transparent bg-sky-500 text-white hover:bg-sky-600',
        warning: 'border-transparent bg-amber-500 text-white hover:bg-amber-600',
        success: 'border-transparent bg-green-500 text-white hover:bg-green-600',
        fire: 'border-transparent bg-red-500 text-white hover:bg-red-600',
        special:
          'border border-purple-400 bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 text-white hover:opacity-90',
        dark: 'border border-gray-700 bg-gray-900 text-gray-100 hover:bg-gray-800',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
